export default __webpack_public_path__ + "static/media/info-mark.7383a7ab.svg";